import React from 'react';

import WalletCard from './WalletCard';
import CurrencySwitch from './CurrencySwitch';

export default class Wallet extends React.Component {
  static Card = WalletCard;
  static CurrencySwitch = CurrencySwitch;
}
